<template>
  <v-container fluid :class="{'hero' :  mobile}">
    <div v-if="mobile">
      <div class="play-page mx-auto mt-md-10">
        <v-row class="d-flex justify-center">
            <v-col cols="" lg="6" md="6" sm="12" xs="12" class="main-play-page pt-16">

              <div class="d-flex flex-column flex-sm-row align-center justify-center">
                <div class="">
                  <img src="./../assets/sww.png"  style="width:100%" />
                </div>

              </div>
              <v-form
                  ref="form"
                  v-model="valid"
                  lazy-validation
                  @submit="submit()"
              >


                <v-alert
                    border="left"
                    colored-border
                    color="rgb(248, 158, 2)"
                    style="background-color:rgb(16,16,16)"
                    class="font-weight-bold"
                    dark
                >
                  REGISTER AN ACCOUNT
                </v-alert>
                <v-divider></v-divider>

                <p class="body-2 my-2 white--text pl-2">YOUR MOBILE NUMBER</p>
                <v-text-field
                    v-model="credentials.mobile"
                    type="number"
                    :loading="busy"
                    :rules="[rules.required, rules.phone]"
                    :error-messages="error && error.mobile ? error.mobile[0] : ''"
                    required
                    autocomplete="new-password"
                    solo
                    outlined
                    hide-details="auto"
                    background-color="#303337"
                    class="pr-2 pl-2 pb-5"

                >
                </v-text-field>
                <p class="body-2 my-2 white--text pl-2">Name</p>
                <v-text-field
                    v-model="credentials.name"
                    :loading="busy"
                    :rules="[rules.required]"
                    :error-messages="error && error.name ? error.name[0] : ''"
                    required
                    autocomplete="new-password"
                    solo
                    outlined
                    hide-details="auto"
                    background-color="#303337"
                    class="pr-2 pl-2 pb-5"
                >
                </v-text-field>
                <p class="body-2 my-2 white--text pl-2">Password</p>
                <v-text-field
                    v-model="credentials.password"
                    :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="show1 ? 'text' : 'password'"
                    @click:append="show1 = !show1"
                    :loading="busy"
                    :rules="[rules.required, rules.password]"
                    :error-messages="error && error.password ? error.password[0] : ''"
                    required
                    autocomplete="new-password"
                    solo
                    outlined
                    hide-details="auto"
                    background-color="#303337"
                    class="pr-2 pl-2 pb-5"

                ></v-text-field>

                <p class="body-2 my-2 white--text pl-2">Confirm Password</p>
                <v-text-field
                    v-model="credentials.password_confirmation"
                    :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="show2 ? 'text' : 'password'"
                    @click:append="show2 = !show2"
                    :loading="busy"
                    :rules="[
                      rules.required,
                      rules.password,
                      passwordConfirmationRule,
                    ]"
                    :error-messages="
                      error && error.password_confirmation
                        ? error.password_confirmation[0]
                        : ''
                    "
                    @keypress.enter="submit()"
                    required
                    autocomplete="new-password"
                    solo
                    outlined
                    hide-details="auto"
                    background-color="#303337"
                    class="pr-2 pl-2 pb-5"

                ></v-text-field>
                <div class="mt-2 mb-4 pl-2">
                  <v-checkbox
                      class="mt-0 mb-1"
                      v-model="credentials.terms"
                      required
                      hide-details
                      :rules="[(v) => !!v || '']"
                  >
                    <template v-slot:label>
                      <a
                          href="#"
                          class="terms-link"
                          @click.stop.prevent="
                            terms = true;
                            credentials.terms = true;
                          "
                      >
                        &nbsp;Terms and Conditions
                      </a>
                    </template>
                  </v-checkbox>
                </div>
                <div class="text-center mt-5 pt-3 pl-2 pr-2 mb-5">
                  <v-btn
                      color="rgb(248, 158, 2)"
                      class="mb-4 black--text"
                      @click="submit()"
                      :loading="busy"
                      :disabled="!credentials.terms"
                      block
                      large
                  >Register</v-btn
                  >

                  <v-btn
                      color="white"
                      block
                      outlined
                      class="mb-"
                      @click.stop="$router.push({ name: 'login' })"
                  >Login</v-btn
                  >
                  <div v-if="this.credentials.ref" color="grey--text">
                    <small>{{ this.credentials.ref }}</small>
                  </div>
                </div>
              </v-form>
            </v-col>

        </v-row>
      </div>
    </div>

    <div v-else>
      <v-row no-gutters class="pt-10">
      <v-col >    

        <div class="d-flex flex-column flex-sm-row align-center justify-center">

        <div>
          <img src="./../assets/sww.png" class="login-logo" />
        </div>

        <v-form
            ref="form"
            v-model="valid"
            lazy-validation
            class="main-form"
            @submit="submit()"
            style="background-color:rgb(16,16,16);width:100%"
          >


            <v-alert
              color="#ffdc11"
              style="background-color:rgb(16,16,16)"
              class="font-weight-bold text-center"
              dark
            >
             REGISTER
            </v-alert>
            <v-divider></v-divider>

            <p class="body-2 my-2 white--text pl-2">YOUR MOBILE NUMBER</p>
            <v-text-field
              dense
              v-model="credentials.mobile"
              type="number"
              :loading="busy"
              :rules="[rules.required, rules.phone]"
              :error-messages="error && error.mobile ? error.mobile[0] : ''"
              required
              autocomplete="new-password"
              solo
              outlined
              hide-details="auto"
              background-color="#303337"
              class="pr-2 pl-2 pb-5"

            >
            </v-text-field>
            <p class="body-2 my-2 white--text pl-2">Name</p>
            <v-text-field
              dense
              v-model="credentials.name"
              :loading="busy"
              :rules="[rules.required]"
              :error-messages="error && error.name ? error.name[0] : ''"
              required
              autocomplete="new-password"
              solo
              outlined
              hide-details="auto"
              background-color="#303337"
              class="pr-2 pl-2 pb-5"
            >
            </v-text-field>
            <p class="body-2 my-2 white--text pl-2">Password</p>
            <v-text-field
              dense
              v-model="credentials.password"
              :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
              :type="show1 ? 'text' : 'password'"
              @click:append="show1 = !show1"
              :loading="busy"
              :rules="[rules.required, rules.password]"
              :error-messages="error && error.password ? error.password[0] : ''"
              required
              autocomplete="new-password"
              solo
              outlined
              hide-details="auto"
              background-color="#303337"
              class="pr-2 pl-2 pb-5"

            ></v-text-field>

            <p class="body-2 my-2 white--text pl-2">Confirm Password</p>
            <v-text-field
              dense
              v-model="credentials.password_confirmation"
              :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
              :type="show2 ? 'text' : 'password'"
              @click:append="show2 = !show2"
              :loading="busy"
              :rules="[
                rules.required,
                rules.password,
                passwordConfirmationRule,
              ]"
              :error-messages="
                error && error.password_confirmation
                  ? error.password_confirmation[0]
                  : ''
              "
              @keypress.enter="submit()"
              required
              autocomplete="new-password"
              solo
              outlined
              hide-details="auto"
              background-color="#303337"
              class="pr-2 pl-2 pb-5"

            ></v-text-field>
            <div class="mt-2 mb-4 pl-2">
              <v-checkbox
                class="mt-0 mb-1"
                v-model="credentials.terms"
                required
                hide-details
                :rules="[(v) => !!v || '']"
              >
                <template v-slot:label>
                  <a
                    href="#"
                    class="terms-link grey--text"
                    @click.stop.prevent="
                      terms = true;
                      credentials.terms = true;
                    "
                  >
                    &nbsp;Terms and Conditions
                  </a>
                </template>
              </v-checkbox>
            </div>
            <div class="text-center mt-5 pt-3 mb-5">
              <v-btn
                color="rgb(248, 158, 2)"
                class="mb-4 black--text"
                @click="submit()"
                :loading="busy"
                :disabled="!credentials.terms"
                block
                large
                >Register</v-btn
              >

              <v-btn
                color="white"
                block
                outlined
                class="mb-2"
                @click.stop="$router.push({ name: 'login' })"
                >Login</v-btn
              >
              <div v-if="this.credentials.ref" color="grey--text">
                <small>{{ this.credentials.ref }}</small>
              </div>
            </div>
          </v-form>

        </div>

      </v-col>
    </v-row>
    </div>

    <v-dialog v-model="terms" max-width="600">
      <v-card class="terms-modal">
        <div class="win-content px-5 py-4 text-justify" style="background-color:#B71C1C">
          <terms />
        </div>
        <v-card-actions class="sticky-bottom">
          <v-btn block color="rgb(248, 158, 2)" light @click.stop.prevent="terms = false"
            ><span style="color:white" class="font-weight-medium">I AGREE</span></v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog light v-model="show_prompt" max-width="600">
              <v-card class="terms-modal white--text" color="rgb(16 16 16)">
                  <v-card-title class="body-2 text-uppercase py-4 px-3 yellow--text text--darken-4  d-flex justify-center text-h5">
                      Confirm Number
                  </v-card-title>
                  <v-card-text>
                      <div class="win-content px-5 py-4 text-justify grey--text">
                          Please make sure that phone number is active and available.
                          Phone number will be used for verification later on.
                      </div>
                  </v-card-text>
                  <v-card-actions class="justify-center pb-6">
                      <v-btn @click.stop.prevent="willProceed(false)" class="px-5 px-sm-16 text-uppercase white--text font-weight-medium grey darken-2 text-button">cancel</v-btn>
                      <v-btn light
                             @click.stop.prevent="willProceed(true)" class="px-5 px-sm-16 text-uppercase white--text font-weight-medium green darken-2 text-button">OK</v-btn>
                  </v-card-actions>
              </v-card>
          </v-dialog>
    

  </v-container>
</template>

<script>
import mixin from "./../mixins";
import auth from "./../mixins/auth";
import rules from "./../mixins/rules";

export default {
  mixins: [mixin, auth, rules],
  data: () => ({
    valid: true,
    show1: false,
    show2: false,
    terms: false,
    show_prompt: false,
    credentials: {
      mobile: null,
      name: null,
      password: null,
      password_confirmation: null,
      guid: null,
      ref: null,
      terms: false,
    },
  }),
  components: {
  },
  computed: {
    passwordConfirmationRule() {
      return (
        this.credentials.password === this.credentials.password_confirmation ||
        "Password must match"
      );
    },

    mobile() {
      return this.$vuetify.breakpoint.mdAndUp;
    },

  },
  methods: {
    submit() {
      if (this.$refs.form.validate()) this.show_prompt = true;
    },
    verifyInvitationCode() {
      this.getData(
        `/auth/verify-invitation-code/${this.credentials.ref}`,
          response => {
            if (response.exists === undefined || !response.exists) {
              this.redirectTo404()
            }
          },
          () => {
            this.redirectTo404()
          }
      )
    },
    redirectTo404() {
      this.$router.replace({ name: 'not-found' })
      },
    willProceed(will_proceed) {
      this.show_prompt = false;
      if(will_proceed)this.register(this.credentials);
    }
  },
  mounted() {
    if (this.$route.query) {
      this.credentials.guid = this.$route.query?.guid || null;

      if(this.$route.query.ref) {
        this.credentials.ref = this.$route.query.ref || null;
        this.verifyInvitationCode();
      }
    }
  },
};
</script>

<style scoped>
.hero {
  background: url('./../assets/sww-background.png');
  background-size: cover;
  /*height: 100vh;*/
  width:100%;
}
</style>
